import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { formatMoneda, validaMonto } from "../../../util/varios";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";

import { Select, Input } from "../../../ui/inputs/Input";
import { DangerButton, SuccessButton } from "../../../ui/buttons/Button";

export const AgregarDescuento = (props) => {
  const btnAcepta = useRef();
  const btnCancela = useRef();
  const txtValor = useRef();
  const diaDesde = useRef();
  const mesDesde = useRef();
  const diaHasta = useRef();
  const mesHasta = useRef();

  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mostrar, setMostrar] = useState(false);
  const [activate, setActivate] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const blanquear = () => {
    setMostrar(false);
    setTitulo("");
    setMsg("");
    setActivate(false);
  };

  const handleValidarDia = (event) => {
    if (event.target.name === "diaDesde") {
      if (diaDesde.current.value > "29" && mesDesde.current.value === "2") {
        setMensaje({
          mostrar: true,
          titulo: "Información",
          texto: "Dia Invalido",
          icono: "informacion",
        });
        diaDesde.current.value = "01";
        diaDesde.current.focus();
      } else if (
        diaDesde.current.value === "31" &&
        mesDesde.current.value === "11"
      ) {
        setMensaje({
          mostrar: true,
          titulo: "INformación",
          texto: "Día Invalido",
          icono: "informacion",
        });
        diaDesde.current.value = "01";
        diaDesde.current.focus();
      }
    } else if (event.target.name === "diaHasta") {
      if (diaHasta.current.value > "29" && mesHasta.current.value === "2") {
        setMensaje({
          mostrar: true,
          titulo: "Información",
          texto: "Dia Invalido",
          icono: "informacion",
        });
        diaHasta.current.value = "01";
        diaHasta.current.focus();
      } else if (
        diaHasta.current.value > "31" &&
        mesDesde.current.value === "11"
      ) {
        setMensaje({
          mostrar: true,
          titulo: "Información",
          texto: "Dia Invalido",
          icono: "informacion",
        });
        diaHasta.current.value = "01";
        diaHasta.current.focus();
      }
    }
  };
  const handleValidarFecha = (event) => {
    switch (event.target.value) {
      case "02":
        if (event.target.name === "mesDesde") {
          if (diaDesde.current.value > "29") {
            setMensaje({
              mostrar: true,
              titulo: "Información",
              texto: "Dia Invalido",
              icono: "informacion",
            });
            diaDesde.current.value = "01";
            diaDesde.current.focus();
          }
        } else if (event.target.name === "mesHasta") {
          if (diaHasta.current.value > "29") {
            setMensaje({
              mostrar: true,
              titulo: "Información",
              texto: "Dia Invalido",
              icono: "informacion",
            });
            diaHasta.current.value = "01";
            diaHasta.current.focus();
          }
        }
        break;
      case "04":
      case "06":
      case "09":
      case "11":
        if (event.target.name === "mesDesde") {
          if (diaDesde.current.value === "31") {
            setMensaje({
              mostrar: true,
              titulo: "Información",
              texto: "Dia Invalido",
              icono: "informacion",
            });
            diaDesde.current.value = "01";
            diaDesde.current.focus();
          }
        } else if (event.target.name === "mesHasta") {
          if (diaHasta.current.value > "31") {
            setMensaje({
              mostrar: true,
              titulo: "Información",
              texto: "Dia Invalido",
              icono: "informacion",
            });
            diaHasta.current.value = "01";
            diaHasta.current.focus();
          }
        }
        break;
    }
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", ".")
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which >= 37 && event.which <= 40) {
      event.preventDefault();
    }
    let e = event.target.value
      .replace(/\D/g, "")
      .replace(/([0-9])([0-9]{2})$/, "$1.$2")
      .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");
    return formatMoneda(e);
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    blanquear();
    props.onHideCancela();
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancela();
  };

  const aceptar = () => {
    var ini = mesDesde.current.value;
    var fin = mesHasta.current.value;
    var porce = txtValor.current.value;
    if (parseInt(ini) > parseInt(fin)) {
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "El Periodo Desde debe ser menor que el Periodo Hasta",
        icono: "informacion",
      });
      diaDesde.current.focus();
    } else if (txtValor.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "El valor no debe estar en blanco",
        icono: "informacion",
      });
      txtValor.current.focus();
    } else if (txtValor.current.value.trim() === "0,00") {
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "El valor no debe ser cero",
        icono: "informacion",
      });
      txtValor.current.focus();
    } else if (diaDesde.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "Debe Seleccionar un Dia de Inicio",
        icono: "informacion",
      });
      diaDesde.current.focus();
    } else if (mesDesde.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "Debe Seleccionar un Mes de Inicio",
        icono: "informacion",
      });
      mesDesde.current.focus();
    } else if (diaHasta.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "Debe Seleccionar un Dia de Final",
        icono: "informacion",
      });
      diaHasta.current.focus();
    } else if (mesHasta.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "Debe Seleccionar un Mes de Final",
        icono: "informacion",
      });
      mesHasta.current.focus();
    } else {
      props.onHideAcepta(ini, fin, porce);
      setMensaje({
        mostrar: true,
        titulo: "Exito.",
        texto: "La tabla fue actualizada",
        icono: "exito",
      });
    }
  };

  const editar = (descuento) => {
    diaDesde.current.value = descuento.periodoini.toString().substring(0, 2);
    mesDesde.current.value = descuento.periodoini.toString().substring(3, 5);
    diaHasta.current.value = descuento.periodofin.toString().substring(0, 2);
    mesHasta.current.value = descuento.periodofin.toString().substring(3, 5);
    txtValor.current.value = formatMoneda(
      descuento.porcentaje.toString().replace(".", ","),
      ",",
      ".",
      2
    );
  };

  return (
    <Modal
      {...props}
      size="sm"
      style={{ backgroundColor: "rgb(0,0,0,0.3)" }}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        if (props.tipoconf === 2) {
          editar(props.descuento);
        }
      }}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light">
        <h3 className="fw-bold m-0">
          {props.tipoconf === 1
            ? "Agregar Descuento"
            : props.tipoconf === 2
            ? "Editar Descuento"
            : "Eliminar Descuento"}
        </h3>
        <a type = 'button'
          ref={btnCancela}
          className="fw-bold text-light fs-6"
          onClick={cancelar}
        >
          Salir <i className="fa fa-times"></i>  
        </a>
      </Modal.Header>
      <Modal.Body className = 'col-12 m-0 p-2'>
        <div class="col-12 m-0 mb-2 p-0 d-flex">
            <Select label = 'Desde:'
            name="diaDesde"
            onKeyUp={handleValidarDia}
            onBlur={handleValidarDia}
            ref={diaDesde}
            >
            <option value="">Dia</option>
            <option value="01">01</option>
            <option value="02">02</option>
            <option value="03">03</option>
            <option value="04">04</option>
            <option value="05">05</option>
            <option value="06">06</option>
            <option value="07">07</option>
            <option value="08">08</option>
            <option value="09">09</option>
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
            <option value="13">13</option>
            <option value="14">14</option>
            <option value="15">15</option>
            <option value="16">16</option>
            <option value="17">17</option>
            <option value="18">18</option>
            <option value="19">19</option>
            <option value="20">20</option>
            <option value="21">21</option>
            <option value="22">22</option>
            <option value="23">23</option>
            <option value="24">24</option>
            <option value="25">25</option>
            <option value="26">26</option>
            <option value="27">27</option>
            <option value="28">28</option>
            <option value="29">29</option>
            <option value="30">30</option>
            <option value="31">31</option>
            </Select>
            <Select
            name="mesDesde"
            onKeyUp={handleValidarFecha}
            onBlur={handleValidarFecha}
            ref={mesDesde}
            >
            <option value="">Mes</option>
            <option value="01">01</option>
            <option value="02">02</option>
            <option value="03">03</option>
            <option value="04">04</option>
            <option value="05">05</option>
            <option value="06">06</option>
            <option value="07">07</option>
            <option value="08">08</option>
            <option value="09">09</option>
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
            </Select>
        </div>
        <div class="col-12 m-0 mb-2 p-0 d-flex">
            <Select label = 'Hasta:'
            name="diaHasta"
            onKeyUp={handleValidarDia}
            onBlur={handleValidarDia}
            ref={diaHasta}
            >
            <option value="">Dia</option>
            <option value="01">01</option>
            <option value="02">02</option>
            <option value="03">03</option>
            <option value="04">04</option>
            <option value="05">05</option>
            <option value="06">06</option>
            <option value="07">07</option>
            <option value="08">08</option>
            <option value="09">09</option>
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
            <option value="13">13</option>
            <option value="14">14</option>
            <option value="15">15</option>
            <option value="16">16</option>
            <option value="17">17</option>
            <option value="18">18</option>
            <option value="19">19</option>
            <option value="20">20</option>
            <option value="21">21</option>
            <option value="22">22</option>
            <option value="23">23</option>
            <option value="24">24</option>
            <option value="25">25</option>
            <option value="26">26</option>
            <option value="27">27</option>
            <option value="28">28</option>
            <option value="29">29</option>
            <option value="30">30</option>
            <option value="31">31</option>
            </Select>
            <Select
            name="mesHasta"
            onKeyUp={handleValidarFecha}
            onBlur={handleValidarFecha}
            ref={mesHasta}
            >
            <option value="">Mes</option>
            <option value="01">01</option>
            <option value="02">02</option>
            <option value="03">03</option>
            <option value="04">04</option>
            <option value="05">05</option>
            <option value="06">06</option>
            <option value="07">07</option>
            <option value="08">08</option>
            <option value="09">09</option>
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
            </Select>
        </div>
        <div class="col-12 m-0 p-0">
            <Input label = 'Valor Del Descuento:'
            ref={txtValor}
            onKeyUp={handleInputMontoChange}
            onBlur={handleInputMontoChange}
            defaultValue="0,00"
            id="txtValor"
            />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          ref={btnAcepta}
          onClick={aceptar}
        >
            Aceptar
        </SuccessButton>
        <DangerButton
          ref={btnCancela}
          onClick={cancelar}
        >
            Cancelar
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />

      <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};
